<template>
  <div id="consultation-overview">
    <div class="header-side">
      <v-btn @click="submitAnswer('back')" class="prg-header-btn" rounded icon>
        <v-icon size="36px" class="prg-header-icon">mdi-chevron-left</v-icon>
      </v-btn>
      <div class="btn-text"><a @click="submitAnswerFromCard('back')"> zurück </a></div>
    </div>
    <div class="consultation-container">
      <div class="overview-container">
        <v-row>
          <v-col class="basket-col" flex-direction:column>
            <div class="shadow-box">
              <div class="title">Ihre gemerkten {{textContent.productSummaryTypeNom}}</div>
              <div class="hm-list">
                <v-list flat>
                  <v-list-item
                    class="nav-item"
                    v-for="(listBasketData, productID, i) in currentBasketItemsOnPage"
                    :key="i"
                    link
                  >
                    <v-img contain height="110px" max-width="110px" class="nav-tile" :src="listBasketData.img"> </v-img>
                    <v-list-item-content>
                      <v-list-item-title>{{ listBasketData.title }}</v-list-item-title>
                    </v-list-item-content>
                    <div class="price-info">
                      <div class="price" align="center">
                        ab {{ productData[productID].costInformation.priceFrom }} EUR
                      </div>
                      <div class="terms">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-if="productData[productID].costInformation.costTakeoverType"
                              class="price-info-btn"
                              @click="showPriceModal(productID)"
                              v-bind="attrs"
                              v-on="on"
                              icon
                            >
                              <v-icon color="white">mdi-cash-sync</v-icon>
                            </v-btn>
                            <v-btn
                              v-else
                              class="price-info-btn-notakeover"
                              @click="showPriceModal(productID)"
                              v-bind="attrs"
                              v-on="on"
                              icon
                            >
                              <v-icon color="white">mdi-cash-sync</v-icon>
                            </v-btn>
                          </template>
                          <span>Infos zur Kostenübernahme anzeigen</span>
                        </v-tooltip>
                        <div v-if="productData[productID].costInformation.costTakeoverType" class="takeover-info-text">
                          Kassenübernahme<br />möglich
                        </div>
                        <div v-else class="takeover-info-text">Kassenübernahme<br />nicht möglich</div>
                      </div>
                    </div>
                    <v-list-item-action>
                      <div class="counter-btn__wrap">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              class="counter-btn"
                              small
                              dark
                              depressed
                              @click="triggerRemoveItemModal(productID)"
                            >
                              <v-icon small>mdi-close-thick</v-icon>
                            </v-btn>
                          </template>
                          <span>Von Merkliste entfernen</span>
                        </v-tooltip>
                      </div>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
                <v-pagination
                  v-if="Math.ceil(Object.keys($store.state.basketModule.basket).length / hmListPagination.maxItemsPerPage) > 1"
                  v-model="hmListPagination.currentPage"
                  :length="Math.ceil(Object.keys($store.state.basketModule.basket).length / hmListPagination.maxItemsPerPage)"
                ></v-pagination>
              </div>
            </div>
          </v-col>

          <v-col class="signup-col">
            <div class="shadow-box">
              <div class="title">Sie haben es fast geschafft!</div>
              <div class="signup-top">
                <div class="signup-avatar">
                  <img alt="anni logo" width="100px" height="100px" src="../assets/ANNI_Design_Round_Image_Green.png" />
                </div>
                <div class="signup-top-text">
                  Sie sind nur noch einen Schritt davon entfernt, Ihre {{textContent.productSummaryTypeNom}} auf dem schnellsten Weg zu erhalten. 
                </div>
              </div>

              <div class="signup-content">
                <p>Im nächsten Schritt:</p>
                <ul>
                  <li>finden Sie <b>passende Anbieter in Ihrer Nähe.</b></li>
                  <li>erfahren Sie, wie Sie <b>Kosten erstattet</b> bekommen.</li>
                  <li v-html=textContent.productCTA>
                  </li>
                </ul>
                <br />
                <p>Finden Sie jetzt passende Anbieter in Ihrer Nähe!</p>
                <!-- <v-text-field
                  placeholder="E-Mail Adresse eingeben"
                  v-model="mailInput"
                  outlined
                  flat
                  block
                  label="E-Mail"
                  class="input"
                  :rules="validationRules"
                ></v-text-field>
                <div class="checkmark-infobox">
                  <div class="checkmark-infoicon">
                    <v-icon color="#6caa9d" size="30px">mdi-information</v-icon>
                  </div>
                  <div class="hint-text">
                    Mit Ihrer E-Mail Adresse können Sie im Anschluss jederzeit wieder Ihre gemerkten {{textContent.productSummaryTypeAcc}}
                    ansehen. Ihre Daten werden mit diesem Schritt nicht an Dritte weitergegeben!
                  </div>
                </div> -->

                <v-btn
                  depressed
                  block
                  class="primary-txt-btn __h68"
                  @click="goToStoreFinder()"
                  >Anbieter finden</v-btn
                >
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
    </div>

    <!-- modal for price information -->
    <v-dialog v-model="priceModalVisible" width="777px">
      <v-card class="dialog-card">
        <div class="body">
          <div class="text-semibold">{{ priceModalContent.title }}</div>
          <div class="text-regular" v-html="priceModalContent.text">
            <p></p>
          </div>
          <v-card-actions>
            <v-btn color="primary" class="primary-txt-btn" text @click="priceModalVisible = false">
              Diesen Hinweis schließen
            </v-btn>
          </v-card-actions>
        </div>
      </v-card>
    </v-dialog>

    <!-- modal for remove from basket confirmation -->
    <v-dialog v-model="showRemoveBasketModal" width="777px">
      <v-card class="dialog-card">
        <div class="body">
          <div class="text-semibold">Möchten Sie folgendes Produkt wirklich von Ihrer Merkliste entfernen?</div>
          <div class="text-regular">
            <v-list flat>
              <v-list-item
                class="nav-item"
                v-for="(listBasketData, productID, i) in selectedBasketItemForRemoval"
                :key="i"
                link
              >
                <v-img contain height="110px" max-width="110px" class="nav-tile" :src="listBasketData.img"> </v-img>
                <v-list-item-content>
                  <v-list-item-title>{{ listBasketData.title }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </div>
          <div class="dialog-yes-no-confirm">
            <v-btn color="primary" class="primary-txt-btn" text @click="removeItemFromBasketAfterConfirm()"> Ja </v-btn>
            <v-btn color="primary" class="primary-txt-btn" text @click="showRemoveBasketModal = false"> Nein </v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    productData: Object,
  },
  data() {
    return {
      textContent: {
        productSummaryTypeNom: "Hilfsmittel", // Nominative, by default texts refer to Hilfsmittel (products), for some cases it's neccessary to switch this term to Umbau-Maßnahmen (services)
        productSummaryTypeAcc: "Hilfsmitteln", // Accusative, by default texts refer to Hilfsmittel (products), for some cases it's neccessary to switch this term to Umbau-Maßnahmen (services)
        productCTA: "können Sie einen <b>Termin mit Expert:innen aus dem Sanitätshaus</b> vereinbaren."
      },
      mailInput: "",
      selectedBasketItemForRemoval: {},
      hmListPagination: {
        currentPage: 1,
        maxItemsPerPage: 4,
      },
      priceModalVisible: false,
      priceModalContent: {
        title: "",
        text: "",
      },
      showRemoveBasketModal: false,
      validationRules: [(input) => this.isValidMail(input) || "Bitte geben Sie eine gültige E-Mail Adresse ein!"],
    }
  },
  methods: {
    goToStoreFinder() {
      let routeData
      if(this.$router.history.current.name == 'customer view for partner sani'){
        routeData = this.$router.resolve({
            name: "SelectionPageApp",
            query: { productHeader: true, chainFilter: this.$router.history.current.params.chainName}
          })
      }else{
        routeData = this.$router.resolve({
            name: "SelectionPageApp",
            query: { productHeader: true }
          })
      }
      window.open(routeData.href, "_blank")
    },
    submitAnswer(type) {
      let newInput = {
        mailbox: {
          enteredText: this.$data.mailInput,
          skipped: false,
        },
      }

      if (type === 'back') {
        newInput = {
          backButton: {
            clicked: true,
          },
        }
      }

      console.log(newInput)
      this.$emit("forwardAnswerToAppForBackendProcessing", newInput)
    },
    triggerRemoveItemModal(productID) {
      this.showRemoveBasketModal = true
      this.selectedBasketItemForRemoval = {}
      this.selectedBasketItemForRemoval[productID] = this.$store.state.basketModule.basket[productID]
    },
    removeItemFromBasketAfterConfirm() {
      this.showRemoveBasketModal = false
      this.$emit("removeItemFromBasket", Object.keys(this.selectedBasketItemForRemoval)[0])
    },
    showPriceModal(productID) {
      this.priceModalVisible = true
      if (this.productData[productID].costInformation.costTakeoverType === "GKV") {
        this.priceModalContent.title = "Was bedeutet Kassenübernahme möglich?"
        this.priceModalContent.text =
          "Die Kosten für dieses Produkt können bei medizinscher Notwendigkeit von der Krankenkasse bezuschusst werden. Dazu benötigen Sie allerdings ein gültiges Rezept. Nähere Informationen zur Verordnung und Kostenübernahme finden Sie in <a href=\"https://anni.care/hilfsmittel/\">unserem Ratgeber</a>."
      }
      else if (this.productData[productID].costInformation.costTakeoverType === "GPV"){
        this.priceModalContent.title = "Was bedeutet Kassenübernahme möglich?"
        this.priceModalContent.text =
          "Die Kosten für dieses Produkt können von der Pflegekasse bezuschusst werden. Dazu benötigen Sie allerdings einen gültigen Pflegegrad. Nähere Informationen zur Verordnung und Kostenübernahme finden Sie in <a href=\"https://anni.care/hilfsmittel/\">unserem Ratgeber</a>."
      }
      else if (this.productData[productID].costInformation.costTakeoverType === "WUVM"){
        this.priceModalContent.title = "Was bedeutet Kassenübernahme möglich?"
        this.priceModalContent.text =
          "Die Pflegekasse bezuschusst Umbau-Maßnahmen unter bestimmten Voraussetzungen mit bis zu 4.000€. Nähere Informationen zu den wohnumfeldverbessernden Maßnahmen finden Sie in <a href=\"https://anni.care/hilfsmittel/\">unserem Ratgeber</a>."
      }
      else {
        this.priceModalContent.title = "Was bedeutet Kassenübernahme nicht möglich?"
        this.priceModalContent.text =
          "Die Kosten für dieses Produkt werden in der Regel von keinem Kostenträger übernommen. Sie müssen dieses Produkt also selbst bezahlen."
      }
    },
    // is a duplicate funciton of ContactDetailCard.vue => TODO: common validation function
    isValidMail(input) {
      if (input.length === 0) {
        return false
      }
      let re = new RegExp(
        "^[\\w!#$%&’*+/=?`{|}~^-]+(?:\\.[\\w!#$%&’*+/=?`{|}~^-]+)*@(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,6}$"
      )
      if (re.test(input) === false) {
        return false
      }
      return true
    },
  },
  computed: {
    // slice Basket Items so that they match the selected page
    /* 
    Song Slice and IndexExample: 
        Page 1: 0-3
        Page 2: 4-7
        Page 3: 8-11,
        ...
    */
    currentBasketItemsOnPage() {
      const sliceBeginIndex = (this.hmListPagination.currentPage - 1) * this.hmListPagination.maxItemsPerPage
      const sliceEndIndex = sliceBeginIndex + this.hmListPagination.maxItemsPerPage

      let itemsOnPage = Object.keys(this.$store.state.basketModule.basket)
        .slice(sliceBeginIndex, sliceEndIndex)
        .reduce((result, key) => {
          result[key] = this.$store.state.basketModule.basket[key]
          return result
        }, {})
      return itemsOnPage
    },
  },
  mounted() {
    console.log("mount CONSULTATION OVERVIEW")
    // fires an event to indicate Parent Component that DOM is updated and can be safely accessed
    this.$nextTick(() => {
      this.$emit("readyToUpdate")
    });

    console.log(this.$parent)

    // set text content accordingly if flow = bath renovation
    if (this.$parent.$parent.$parent.originalFlowState.variables.badumbau === true){
      this.textContent.productSummaryTypeNom = "Umbau-Maßnahmen"
      this.textContent.productSummaryTypeAcc = "Umbau-Maßnahmen"
      this.textContent.productCTA = "finden Sie <b>passende Anbieter</b> in Ihrer Nähe."
    }
  },
  destroyed() {
    //TODO: switch to unmount when upgrade to Vue3
    console.log("unmount CONSULTATION OVERVIEW")
  },
}
</script>
